export const NZipFiles = (data, attachment) => {
  const date = new Date();
  const today =
    date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();

  const url = new Blob([data]);
  const blobUrl = URL.createObjectURL(url);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.setAttribute(
    "download",
    attachment.length > 1
      ? `${today} attachments.zip`
      : `${attachment[0].FileName}.zip`
  );
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
};
